export default __webpack_public_path__ + "static/media/animated_logo.abd0b20e.svg";